import API from "@/API";
import store from "@/store/index";

export const getSheetInfomations = async (route) => {
  // getMyticketDetailのAPIを叩いてそのレスポンスをbookGroupとして代入
  await API.getMyticketDetail(route.params.book_group_id);

  // 複数枚の場合と1枚の場合で代入
  var sheetID = route.params.sheet_id.match(/,/)
    ? route.params.sheet_id.split(",")[0]
    : route.params.sheet_id;

  // シートのインデックスを抽出
  let i = null;
  await store.getters["ticketing/bookGroup"].books[0].sheets.forEach(function (
    sheet,
    index
  ) {
    if (sheet.id == sheetID) {
      i = index;
    }
  });

  // 該当シートをstoreへ格納
  store.commit(
    "ticketing/setSheet",
    store.getters["ticketing/bookGroup"].books[0].sheets[i]
  );
  store.commit(
    "ticketing/setMasterSheet",
    store.getters["ticketing/bookGroup"].books[0].sheets[i]._master_sheet
  );
};
